import { Component, inject, Signal } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingIndicatorService } from '#services';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
  imports: [ProgressSpinnerModule],
  standalone: true,
})
export class LoadingIndicatorComponent {
  private readonly loadingIndicatorSvc = inject(LoadingIndicatorService);

  isLoading: Signal<boolean>;

  constructor() {
    this.isLoading = toSignal(this.loadingIndicatorSvc.isVisible$(), { initialValue: false });
  }
}
